import siteApi from '@/api/admin/siteApi'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { SiteID } from '@/types/site'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchSiteId(
  interfaceId: string,
  searchParams: SearchParams = {},
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<SiteID>, any> {
  return useQuery(
    [queryKeys.site, interfaceId, searchParams],
    async () => {
      if (!interfaceId) {
        return null
      }
      const { data } = await siteApi.getById(interfaceId, { ...searchParams })

      if (!data) return null

      // const siteList = data.data.length > 0 && data?.data.map((item: any) => {
      //   return {
      //     id: item.id,
      //     name: item.name,
      //     interfaceId: item.interfaceId,
      //     numOfLocations: item.numOfLocations
      //   }
      // })

      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchSiteId
